import React from 'react'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import Header from './header'
import Question from '~/Common-Objects/UI/Question'
import i18n from '~/i18n'

export default function QuestionsStep1({ answers, setAnswers, errors, userOnly = false }) {
    return (
        <div>
            <Header
                header={i18n.t(userOnly ? 'account:questions.userOnly.header' : 'account:questions.step1.header')}
                subheader={i18n.t(
                    userOnly ? 'account:questions.userOnly.subheader' : 'account:questions.step1.subheader'
                )}
            />
            <Question
                className='mar-b32'
                label={i18n.t('account:questions.step1.question1')}
                required={true}
                name='role'
                value={answers.role}
                onChange={(e) => setAnswers({ ...answers, role: e.target.value })}
                options={[
                    { value: 'Business Owner', label: i18n.t('account:questions.step1.options1.BusinessOwner') },
                    { value: 'Director/VP', label: i18n.t('account:questions.step1.options1.DirectorVP') },
                    { value: 'Marketing', label: i18n.t('account:questions.step1.options1.Marketing') },
                    { value: 'Sales', label: i18n.t('account:questions.step1.options1.Sales') },
                    { value: 'Finance', label: i18n.t('account:questions.step1.options1.Finance') },
                    { value: 'Support', label: i18n.t('account:questions.step1.options1.Support') },
                    { value: 'Customer Success', label: i18n.t('account:questions.step1.options1.CustomerSuccess') },
                    { value: 'Other', label: i18n.t('account:questions.step1.options1.Other') }
                ]}
                error={errors.role}
            />
            {!userOnly && (
                <>
                    <Question
                        className='mar-b32'
                        label={i18n.t('account:questions.step1.question2')}
                        required={true}
                        name='staffSize'
                        value={answers.staffSize}
                        onChange={(e) => setAnswers({ ...answers, staffSize: e.target.value })}
                        options={['1-10', '11-50', '51-100', '101-250', '250+']}
                        error={errors.staffSize}
                    />
                    <Select
                        label={
                            <>
                                {i18n.t('account:questions.step1.question3')} <span className='text-red'>*</span>
                            </>
                        }
                        required={true}
                        name='contacts'
                        value={answers.contacts}
                        placeholderNoSelect={i18n.t('account:questions.step1.placeholder3')}
                        onChange={(e) => setAnswers({ ...answers, contacts: e.target.value })}
                        error={errors.contacts}
                        dropdownStyle={{ position: 'relative' }}
                        data={[
                            { label: '0-1000', value: '0-1000' },
                            { label: '1,000 - 5,000', value: '1000-5000' },
                            { label: '5,000 - 10,000', value: '5000-10000' },
                            { label: '10,000 - 20,000', value: '10000-20000' },
                            { label: '20,000 - 50,000', value: '20000-50000' },
                            { label: '50,000 - 100,000', value: '50000-100000' },
                            { label: '100,000 - 200,000', value: '100000-200000' },
                            { label: '200,000+', value: '200000+' }
                        ]}
                    />
                </>
            )}
            {userOnly && (
                <>
                    <Question
                        className='mar-b32'
                        label={i18n.t('account:questions.step2.question1')}
                        required={true}
                        name='comfort'
                        value={answers.comfort}
                        onChange={(e) => setAnswers({ ...answers, comfort: e.target.value })}
                        options={[
                            { label: i18n.t('account:questions.step2.options1.new'), value: "I'm new" },
                            { label: i18n.t('account:questions.step2.options1.some'), value: 'Some Experience' },
                            { label: i18n.t('account:questions.step2.options1.experienced'), value: 'Experienced' },
                            { label: i18n.t('account:questions.step2.options1.expert'), value: 'Expert' }
                        ]}
                        error={errors.comfort}
                    />
                    <Question
                        label={i18n.t('account:questions.step2.question2')}
                        required={true}
                        name='importantToBusiness'
                        value={answers.importantToBusiness}
                        multiselect={true}
                        onChange={(e) => setAnswers({ ...answers, importantToBusiness: e.target.value })}
                        error={errors.importantToBusiness}
                        options={[
                            { label: i18n.t('account:questions.step2.options2.template'), value: 'Email Templates' },
                            { label: i18n.t('account:questions.step2.options2.automation'), value: 'Automation Tasks' },
                            { label: i18n.t('account:questions.step2.options2.ai'), value: 'AI Content Assistant' },
                            { label: i18n.t('account:questions.step2.options2.tracking'), value: 'Tracking Visitors' },
                            { label: i18n.t('account:questions.step2.options2.social'), value: 'Social Posting' },
                            { label: i18n.t('account:questions.step2.options2.sms'), value: 'SMS Marketing' },
                            {
                                label: i18n.t('account:questions.step2.options2.performance'),
                                value: 'Campaign Performance'
                            },
                            { label: i18n.t('account:questions.step2.options2.chat'), value: 'Web Chat' }
                        ]}
                    />
                </>
            )}
        </div>
    )
}
